import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[cgp-component-browser-host]',
})
export class CgpComponentBrowserDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
